import { PagedRepeat } from "lib/@components/paged-repeat"
import { useSearchParam } from "lib/@hooks/use-search-param"

export function MemorizedPagedRepeat({ id, ...props }) {
    const [page, setPage] = useSearchParam(`${id}-page`, "1", (v) => +v)
    return <PagedRepeat page={+page} onPageChange={setPage} {...props} />
}
